import Detail from './detail';
import EfScrollAni from '@/efscrollani';

export default function ExampleProductA() {
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    return <Detail />;
}
